import { useEffect } from "react";
import { usePostHog as usePostHogLib } from "@posthog/react";
import { getCurrentUser } from "../../services/auth.service";

const usePostHog = () => {
  const posthog = usePostHogLib();

  useEffect(() => {
    if (!posthog) return;
    const user = getCurrentUser();
    if (user) {
      posthog.identify(String(user.id), {
        email: user.email,
        username: user.username,
      });
    }
  }, [posthog]);

  const resetIdentity = () => {
    posthog?.reset();
  };

  return { resetIdentity };
};

export default usePostHog;
